let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5LZAK")).then(() => parcelRequire('arAT1'));